export const MAXIMUM_STOCK = 50; // 在庫数の最大値
export const EVERY_MINUTES = 15; // 時刻関連の選択値は何分単位か
